import { Component } from '@angular/core';

import { MenuController, NavController } from 'ionic-angular';

import { LoginPage } from '../login/login';


interface Slide {
  title: string;
  description: string;
  image: string;
}

@Component({
  templateUrl: 'build/pages/splash-screen/splash-screen.html'
})
export class Splash {
  slides: Slide[];
  showSkip = true;

  constructor(public navCtrl: NavController, public menu: MenuController) {
    this.slides = [
      {
        title: 'Welcome to <b>LetPCO</b>',
        description: 'Looking for quality airport transfer upto 80 &percent; cash long journey jobs',
        image: 'img/ica-slidebox-img-1.png',
      },
      {
        title: 'Fed up with Uber Jobs ?',
        description: 'This is the right time to join as a driver in our firm.',
        image: 'img/ica-slidebox-img-2.png',
      },
      {
        title: 'How Much I Earn ?',
        description: 'You can earn over £1000 per week. Dont miss this golden opportunity.',
        image: 'img/ica-slidebox-img-3.png',
      }
    ];

     
  }

  startApp() {

  this.navCtrl.setRoot(LoginPage);

    // this.navCtrl.push(LoginPage);
  }

  onSlideChangeStart(slider) {
    this.showSkip = !slider.isEnd;
  }

  ionViewDidEnter() {
    // the root left menu should be disabled on the tutorial page
    this.menu.enable(false);
  }

  ionViewWillLeave() {
    // enable the root left menu when leaving the tutorial page
    this.menu.enable(true);
  }

}
